import {
  ApplicationConfig,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { AuthConfig } from 'angular-oauth2-oidc';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authAppInitializerFactory } from './core/auth/auth-app-initializer.factory';
import { authConfig } from './core/auth/auth-config';

import { httpInterceptorProviders } from './core/interceptors';
import { iconsProvider } from './icons-provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top', // Scroll to top after route change
      }),
    ),
    provideHttpClient(withInterceptors([...httpInterceptorProviders])),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: ['/rest/rab/v1'],
        sendAccessToken: true,
      },
    }),
    provideAppInitializer(() => authAppInitializerFactory()),
    { provide: AuthConfig, useValue: authConfig },
    ...iconsProvider,
  ],
};
